<template>
  <div class="meal-schedule-panel">
    <div class="lvyun-profile-banner">
      <h2>随心订排餐</h2>
      <p>配送日历、法定节假日一键导入、每周休息与超时扣减规则集中维护。</p>
    </div>

    <el-tabs v-model="activeTab" class="schedule-tabs">
      <el-tab-pane label="配送日历" name="calendar">
        <subscription-calendar ref="subCalendar" embedded />
      </el-tab-pane>
      <el-tab-pane label="排餐规则" name="config">
        <meal-holiday-config ref="holidayConfig" embedded />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SubscriptionCalendar from './SubscriptionCalendar.vue'
import MealHolidayConfig from './MealHolidayConfig.vue'

export default {
  name: 'MealSchedulePanel',
  components: {
    SubscriptionCalendar,
    MealHolidayConfig
  },
  data() {
    return {
      activeTab: 'calendar'
    }
  },
  watch: {
    '$route.query.tab': {
      immediate: true,
      handler(tab) {
        if (tab === 'config' || tab === 'calendar') {
          this.activeTab = tab
        }
      }
    },
    activeTab(tab) {
      const q = { ...this.$route.query, tab }
      if (this.$route.query.tab !== tab) {
        this.$router.replace({ path: this.$route.path, query: q }).catch(() => {})
      }
      this.$nextTick(() => {
        if (tab === 'config' && this.$refs.holidayConfig && this.$refs.holidayConfig.loadHolidays) {
          this.$refs.holidayConfig.loadHolidays()
        }
        if (tab === 'calendar' && this.$refs.subCalendar && this.$refs.subCalendar.loadMonthOverrides) {
          this.$refs.subCalendar.loadMonthOverrides()
        }
      })
    }
  }
}
</script>

<style scoped>
.meal-schedule-panel {
  padding: 0 4px 24px;
}
.lvyun-profile-banner {
  background: linear-gradient(135deg, #f0f7ff 0%, #e8f4fd 100%);
  border-radius: 12px;
  padding: 24px 28px;
  margin-bottom: 16px;
  border: 1px solid #dbeafe;
}
.lvyun-profile-banner h2 {
  margin: 0 0 8px;
  font-size: 22px;
  color: #1e293b;
}
.lvyun-profile-banner p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}
.schedule-tabs ::v-deep .el-tabs__header {
  margin-bottom: 16px;
}
.schedule-tabs ::v-deep .el-tabs__item {
  font-size: 15px;
  font-weight: 500;
}
</style>
